<template>
  <div class="home">
    <p>Welcome back,{{ username }}</p>
    <div class="dashboard">
      <p style="margin-bottom: 20px; font-family: Satoshi-Bold;">Dashboard</p>
      <div class="flex">
        <div class="total">
          <div>Total Sales <span>{{ dashboard['totalOrder'] }} Orders</span></div>
          <div v-format="'$#,##0.00'">{{ dashboard['totalSales'] }}</div>
          <small>Order Total</small>
        </div>
        <div class="total middle">
          <div>Customer count <span>{{ dashboard['customerCount'] }}</span></div>
          <div class="middle-content">
            <span style="width: 180px;">{{ dashboard['repeatCustomers'] }}</span>
            <span style="width: 90px;" v-format="'0.##%'">{{ dashboard['repurchaseRate'] }}</span>
          </div>
          <div class="middle-content">
            <small>Reoccurring Customers</small>
            <small style="width: 90px;">Repurchase rate</small>
          </div>

        </div>
        <div class="total right" style="border-right: unset;">
          <div>Total SPU <span>{{ dashboard['totalSpu'] }}</span></div>
          <div class="middle-content">
            <span>{{ dashboard['sales'] }}</span>
            <span style="width: 130px;" v-format="'0.##%'">{{ dashboard['inventoryTurnoverRate'] }}</span>
          </div>
          <div class="middle-content">
            <small>Sales</small>
            <small style="width: 130px;">Inventory turnover rate</small>
          </div>
        </div>
      </div>
    </div>

    <div class="orders">
      <div class="title">
        <div>Orders</div>
        <div @click="$router.push({ path: 'Order' })" >View All</div>
      </div>
      <div v-if="orderList && orderList.length > 0">
        <el-table style="border: none !important;" ref="orderTable" :data="orderList" empty-text="No data found">
          <el-table-column prop="createTime" label="Creat Time" min-width="15%">
            <template slot-scope="scope">
              {{ scope.row.createTime === null || scope.row.createTime === undefined ? '--' : scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column prop="orderId" label="ID" min-width="15%">
            <template slot-scope="scope">
              {{ scope.row.orderId === null || scope.row.orderId === undefined ? '--' : scope.row.orderId }}
            </template>
          </el-table-column>
          <el-table-column prop="storeName" min-width="15%" label="Store Name">
            <template slot-scope="scope">
              {{ scope.row.storeName === null || scope.row.storeName === undefined ? '--' : scope.row.storeName }}
            </template>
          </el-table-column>
          <el-table-column prop="state" min-width="10%" label="State">
            <template slot-scope="scope">
              {{ scope.row['orderStatus'] | statusDis }}
            </template>
          </el-table-column>

          <el-table-column prop="totalPrice" min-width="10%" label="Total">
            <template slot-scope="scope">
              {{ scope.row['totalPrice'] ? Number(scope.row['totalPrice']).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '--' }}
            </template>
          </el-table-column>

          <el-table-column label="" min-width="5%">
            <template slot-scope="scope">
              <i class="el-icon-arrow-right arrow" style="cursor: pointer;"
                @click="detailOrder(scope['row'])"></i>
            </template>
          </el-table-column>

        </el-table>

      </div>
      <div v-else style="text-align: center;">No orders available.</div>
    </div>
    <!-- Customers -->
    <div class="orders">
      <div class="title">
        <div>Customers</div>
        <div @click="$router.push({ path: 'Customers' })">View All</div>
      </div>
      <div v-if="customerList && customerList.length > 0">
        <el-table style="border: none !important;" ref="orderTable" :data="customerList" empty-text="No data found">
          <el-table-column prop="lastLoginTime" label="Last login" min-width="18%">
            <template slot-scope="scope">
              <span style="
                        display: -webkit-box;
                        
                        overflow: hidden;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: pre-line; ">
                {{ scope.row.lastLoginTime }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="storeName" label="Store Name" min-width="18%">
            <template slot-scope="scope">
              <span style="
                        display: -webkit-box;
                        
                        overflow: hidden;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: pre-line; ">
                {{ scope.row.storeName }}
              </span>
            </template>

          </el-table-column>
          <el-table-column prop="totalSales" min-width="15%" label="Purchase amount">
            <template slot-scope="scope">
              <span style="
                        display: -webkit-box;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: pre-line; ">
                <template v-if="scope.row.totalSales">
                  {{ scope.row.totalSales ? Number(scope.row.totalSales).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '--' }}
                </template>
                <template v-else>
                  N/A
                </template>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="country" min-width="18%" label="Location">
            <template slot-scope="scope">
              <span style="
                        display: -webkit-box;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: pre-line; ">
                {{ (scope.row['state'] && scope.row['countryCode']) ? scope.row['state'] + ' ' + scope.row['countryCode'] : '--' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="repurchase" min-width="10%" label="Repurchase">
            <template slot-scope="scope">
              <span style="
                        display: -webkit-box;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: pre-line; ">
                {{ scope.row.repurchase ? scope.row.repurchase : 'N/A' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="" width="120">
            <template slot-scope="scope">
              <i class="el-icon-arrow-right arrow" style="cursor: pointer; bottom: 15px;"
                @click="detailCustomer(scope['row'])"></i>
            </template>
          </el-table-column>

        </el-table>

      </div>
      <div v-else style="text-align: center;">No customers available</div>

    </div>

  </div>
</template>

<script>
import { getAction } from '@/api/manage.js'
import qs from 'qs'
import { orderStatusDis } from '../../utils/status'

export default {
  components: {},
  props: {

  },
  watch: {

  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('pro__userInfo')).value,
      dashboard: {
        totalOrder: 'N/A',
        totalSales: 'N/A',
        customerCount: 'N/A',
        repeatCustomers: 'N/A',
        repurchaseRate: 'N/A',
        totalSpu: 'N/A',
        sales: 'N/A',
        inventoryTurnoverRate: 'N/A'
      },
      orderList: [],
      customerList: []
    }
  },
  created() {
    this.loadDashboard()
    
  },
  mounted() {
    this.loadOrders()
    this.loadCustomers()
    
  },
  filters: {
    statusDis: (value) => {
      return orderStatusDis(value)
    }
  },
  methods: {
    async loadDashboard() {
      let res = await getAction(`/v0.2/home/dashboard`)
      this.dashboard = res.result
    },
    async loadOrders() {
      let res = await getAction(`/v0.2/home/orders`, {
        'currentPage': 1,
        'pageSize': 5
      })
      this.orderList = res.result['records']
      
    },
    async loadCustomers() {
      let res = await getAction(`/v0.2/home/customers/dashboard`, {
        'currentPage': 1,
        'pageSize': 5
      })

      this.customerList = res.result['records']
      

    },
    detailOrder(row) {
      this.$router.push({ path: 'OrderDetail', query: { 'orderId': row['orderId'] } })
    },
    detailCustomer(row) {
      this.$router.push({ path: 'CustomersDetail', query: { 'userId': row['userId'] } })
    }
  }
}

</script>

<!-- el-ment样式，不能添加scoped -->
<style lang="less">
.orders .el-table,
.orders .el-table thead {
  color: #262B2F !important;
}

.orders .el-table td.el-table__cell,
.orders .el-table th.el-table__cell.is-leaf {
  border-bottom: unset !important;
}

// 去掉最后一根线
.orders .el-table::before {
  height: unset !important;
}
</style>

<style lang="less" scoped>
.home {
  width: 80%;
  margin: 0 auto;

  >p:nth-child(1) {
    font-size: 25px;
    font-family: Satoshi-Bold;
    margin-bottom: 20px;
  }

  .dashboard,
  .orders {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
  }

  .dashboard {
    .total {
      border-right: 1px dashed #8F8F8F;
      padding-right: 50px;
      width: 25%;

      >div {
        &:nth-child(1) span {
          margin-left: 10px;
          color: #FB541C;
          font-size: 16px;
        }

        &:nth-child(2) {
          margin-top: 20px;
          font-family: Satoshi-Bold;
          font-size: 18px;
        }
      }

      .middle-content {
        display: flex;
        justify-content: space-between;

        small:nth-child(2) {
          margin-left: 30px;
        }
      }

      small {
        color: #5D5D5D;
      }

    }

    .middle {
      width: 45%;
      padding-left: 50px;
    }

    .right {
      width: 35%;
      padding-left: 50px;
    }

  }

  .orders {
    .title {
      display: flex;
      justify-content: space-between;

      >div:nth-child(1) {
        margin-bottom: 20px;
        font-family: Satoshi-Bold;
      }

      >div:nth-child(2) {
        cursor: pointer;
      }
    }
  }

  .arrow {
    position: absolute;
    right: 0px;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/home/brand-home.vue